/**
 * Configuração de pedido por documento no painel Empresas.
 * @param {{
 *   enabled: boolean,
 *   openaiKey: string,
 *   anthropicKey: string,
 *   openaiConfigured: boolean,
 *   anthropicConfigured: boolean,
 *   onEnabledChange: (v: boolean) => void,
 *   onOpenAiKeyChange: (v: string) => void,
 *   onAnthropicKeyChange: (v: string) => void,
 *   disabled?: boolean,
 * }} props
 */
export function StoreDocumentOrderForm({
  enabled,
  openaiKey,
  anthropicKey,
  openaiConfigured,
  anthropicConfigured,
  onEnabledChange,
  onOpenAiKeyChange,
  onAnthropicKeyChange,
  disabled = false,
}) {
  return (
    <div className="space-y-3 rounded-xl border border-emerald-700/20 bg-emerald-500/[0.06] p-4 dark:border-emerald-400/20 dark:bg-emerald-500/[0.08]">
      <p className="text-xs font-semibold uppercase tracking-wide text-emerald-900 dark:text-emerald-200">
        Pedido por documento (NF-e / lista)
      </p>
      <p className="text-[11px] leading-relaxed text-ink/65 dark:text-mist/65">
        O cliente pode enviar XML da NF-e ou CSV com código e quantidade. PDF e foto usam leitura automática; IA
        opcional só quando configurada abaixo.
      </p>
      <label className="flex cursor-pointer items-start gap-3 text-sm font-semibold text-ink dark:text-mist">
        <input
          type="checkbox"
          checked={enabled}
          onChange={(e) => onEnabledChange(e.target.checked)}
          disabled={disabled}
          className="mt-0.5 h-4 w-4 rounded border-ink/30 text-accent focus:ring-accent dark:border-white/25"
        />
        <span>Activar pedido por documento na loja</span>
      </label>
      <label className="block text-sm font-semibold text-ink dark:text-mist">
        OpenAI — API key (opcional, fallback IA)
        <input
          type="password"
          autoComplete="new-password"
          disabled={disabled}
          placeholder="vazio = não alterar"
          value={openaiKey}
          onChange={(e) => onOpenAiKeyChange(e.target.value)}
          className="mt-1 w-full rounded-xl border border-ink/10 bg-white px-3 py-2 font-mono text-sm dark:border-white/10 dark:bg-[#252f2a]"
        />
      </label>
      {openaiConfigured ? (
        <p className="text-[10px] text-ink/55 dark:text-mist/72">Chave OpenAI já guardada. Preencha apenas para substituir.</p>
      ) : null}
      <label className="block text-sm font-semibold text-ink dark:text-mist">
        Anthropic — API key (opcional, usada se OpenAI não estiver configurada)
        <input
          type="password"
          autoComplete="new-password"
          disabled={disabled}
          placeholder="vazio = não alterar"
          value={anthropicKey}
          onChange={(e) => onAnthropicKeyChange(e.target.value)}
          className="mt-1 w-full rounded-xl border border-ink/10 bg-white px-3 py-2 font-mono text-sm dark:border-white/10 dark:bg-[#252f2a]"
        />
      </label>
      {anthropicConfigured ? (
        <p className="text-[10px] text-ink/55 dark:text-mist/72">
          Chave Anthropic já guardada. Preencha apenas para substituir.
        </p>
      ) : null}
    </div>
  );
}
